export default {
  name: 'collectionHeader',
  components: {},
  props: ['collectionId', 'sectiondata'],
  computed: {
    panelIcon2() {
      if (this.error === false) {
        let panelIconName = [...this.sections.panelIcons];
        for (let i = 0; i < panelIconName.length; i++) {
          if (this.sections.panelIcons[i] === 'reviews-5000') {
            panelIconName[i] = 'Reviewed 5000+ Times';
          }
          if (this.sections.panelIcons[i] === 'fair-trade-certification') {
            panelIconName[i] = 'Fair Trade Certification';
          }
          if (this.sections.panelIcons[i] === 'free-returns-exchanges') {
            panelIconName[i] = 'Easy Returns & Exchanges';
          }
          if (this.sections.panelIcons[i] === 'gear-for-good') {
            panelIconName[i] = 'Guaranteed for Good™';
          }
          if (this.sections.panelIcons[i] === 'lifetime-warranty') {
            panelIconName[i] = 'Lifetime Warranty & Repairs';
          }
          if (this.sections.panelIcons[i] === 'primaloft-gold') {
            panelIconName[i] = 'PrimaLoft® Gold Insulation';
          }
          if (this.sections.panelIcons[i] === 'rds-down') {
            panelIconName[i] = 'Responsibly Sourced Down';
          }
          if (this.sections.panelIcons[i] === 'repurposed') {
            panelIconName[i] = '(Re)Purposed®';
          }
          if (this.sections.panelIcons[i] === 'reversible') {
            panelIconName[i] = 'Reversible Design';
          }
          if (this.sections.panelIcons[i] === 'bci-cotton') {
            panelIconName[i] = 'Better Cotton Initiative';
          }
          if (this.sections.panelIcons[i] === 'blue-sign') {
            panelIconName[i] = 'Blue Sign Certified';
          }
          if (this.sections.panelIcons[i] === 'gots') {
            panelIconName[i] = 'Global Organic Textile Standard';
          }
          if (this.sections.panelIcons[i] === 'limited-edition') {
            panelIconName[i] = 'Limited Edition';
          }
          if (this.sections.panelIcons[i] === 'recycled-100') {
            panelIconName[i] = 'Recycled or Leftover Fabric';
          }
          if (this.sections.panelIcons[i] === 'one-of-a-kind') {
            panelIconName[i] = 'One-Of-A-Kind';
          }
          if (this.sections.panelIcons[i] === 'organic-cotton') {
            panelIconName[i] = 'Organic Cotton';
          }
        }
        return panelIconName;
      }
    },
    classObject: function () {
      return {
        panel: this.sections.bannerLayout == 'panel',
        left: this.sections.bannerLayout == 'left',
        right: this.sections.bannerLayout == 'right',
        center: this.sections.bannerLayout == 'center',
      };
    },
    colorToggle: function () {
      return this.sections.bannerLightMode == true
        ? 'dark-title'
        : 'light-title';
    },
  },
  data() {
    return {
      isLoading: true,
      error: false,
      sections: {},
    };
  },
  methods: {
    getClass() {
      return {
        'offset-lg-4': this.sections.bannerLayout == 'right',
      };
    },
    getBg() {
      let screenWidth =
        window.innerWidth > 0 ? window.innerWidth : screen.width;
      //show mobile background image if exists
      if (this.sections.bannerLayout != 'panel') {
        if (screenWidth < 768) {
          if (this.sections.mobileBannerBackground != null) {
            return this.optimizeImg(this.sections.mobileBannerBackground.url);
          } else if (this.sections.desktopBannerBackground != null) {
            return;
          } else {
            return;
          }
        } else if (this.sections.desktopBannerBackground) {
          return this.optimizeImg(this.sections.desktopBannerBackground.url); 
        } else {
          return;
        }
      }
    },
    checkForError() {
      if (Object.keys(this.sections).length === 0) { 
        this.error = true;
      }
    },
    optimizeImg(url) {
      // ensure we aren't getting full quality pngs from cloudinary
      // which will significantly reduce image sizes
      return url.replace('/upload', '/upload/w_1300/f_auto,q_auto'); 
    },
  },
  mounted() {
    this.sections = this.sectiondata;
    this.isLoading = false;
    this.checkForError();
  },
};
